import clsx from "clsx";
import { TextProps } from "./PropsTypes";

export default function TextParagraph({ children, className, onClick }: TextProps) {
	return (
		<div className={clsx("text-sm", className)} onClick={() => onClick && onClick()}>
			{children}
		</div>
	);
}
